/**
 * Stable CSS class names for E2E — Communication preference (grid + V2 host).
 */
export const CPREF = {
    v2Page: 'customer-communication-preference-v2-page',
    v2Title: 'customer-communication-preference-v2-page__title',
    v2GridsContainer: 'customer-communication-preference-v2-page__grids-container',

    gridCard: 'customer-communication-preference-grid__card',
    gridToolbar: 'customer-communication-preference-grid__toolbar',
    gridToolbarInner: 'customer-communication-preference-grid__toolbar-inner',
    fieldPreferenceSwitch: 'customer-communication-preference-field--preference-switch',
    inputSwitchPreference: 'customer-communication-preference-input--switch-preference',
    blockLastUpdated: 'customer-communication-preference-grid__block-last-updated',
    blockPlatform: 'customer-communication-preference-grid__block-platform',
    toggleDetailRow: 'customer-communication-preference-grid__toggle-detail-row',
    inputToggleDetail: 'customer-communication-preference-input--toggle-detail',
    collapseSection: 'customer-communication-preference-grid__collapse-section',
    datagrid: 'customer-communication-preference-grid__datagrid',
} as const;

export const cprefCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
